import { useMemo } from "react";
import { useSelector } from "react-redux";

import { ForecastActivityType, TYPE_WELLS } from "constants/settings.constants";
import { RootState } from "store/rootReducer";
import { transformFolderToNestedTreeData } from "utils/arps/treeDataHelper";

import { useForecastContext } from "../context";

export const useTreeData = (type: ForecastActivityType) => {
  const filteredForecastFolders = useSelector(
    (state: RootState) => state.arps.filteredForecastFolders
  );
  const filteredTypeWellFolders = useSelector(
    (state: RootState) => state.arps.filteredTypeWellFolders
  );
  const { temporaryForecastFolderList, isFiltering } = useForecastContext();
  const filteredFolders =
    type === TYPE_WELLS ? filteredTypeWellFolders : filteredForecastFolders;

  const treeData = useMemo(() => {
    const combinedData = isFiltering
      ? filteredFolders
      : [...filteredFolders, ...temporaryForecastFolderList];

    /* eslint-disable @typescript-eslint/no-explicit-any */
    // using any here since this could take in either a folder or an arps item
    const deepUnfreezeFolder = (folder: any): any => {
      const isFolderFrozen = Object.isFrozen(folder);
      const isChildrenFrozen = folder.children ? Object.isFrozen(folder.children) : false;
      const hasAnyFrozenChild = folder.children?.some((child: any) =>
        Object.isFrozen(child)
      );

      if (!isFolderFrozen && !isChildrenFrozen && !hasAnyFrozenChild) {
        return folder;
      }

      const unfrozenFolder = {
        ...folder,
        children: folder.children
          ? folder.children.map((child: any) => {
              if (child.children && child.children.length > 0) {
                return deepUnfreezeFolder(child);
              }
              return { ...child };
            })
          : folder.children
      };

      return unfrozenFolder;
    };

    const unfrozenData = combinedData.map(deepUnfreezeFolder);

    const filteredData =
      type === TYPE_WELLS ? transformFolderToNestedTreeData(unfrozenData) : unfrozenData;

    return filteredData;
  }, [type, filteredFolders, temporaryForecastFolderList, isFiltering]);

  return {
    treeData
  };
};
